import React, { useState } from 'react';
import { useAppDispatch } from '../../store';
import { logout } from '../../store/authSlice';
import './OnboardingLogoutButton.css';

const OnboardingLogoutButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    if (isLoggingOut) return;

    setIsLoggingOut(true);
    try {
      await dispatch(logout()).unwrap();
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <button
      type="button"
      className="onboarding-logout-btn"
      onClick={handleLogout}
      disabled={isLoggingOut}
      title="Log out"
      aria-label="Log out"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </svg>
    </button>
  );
};

export default OnboardingLogoutButton;
